import { createReducer, on } from '@ngrx/store';
import { TokenDto } from '../../shared/models/franchise/franchise.model';
import { authenticateUser, unauthenticateUser } from './user.actions';

const initialState: TokenDto = new TokenDto();

export const userReducer = createReducer(
  initialState,
  // AB#92976: the second argument to an `on()` handler is the ACTION, and `props()` spreads
  // the payload flat onto it — so returning it verbatim made `type` a field of user state,
  // which `UserEffects.saveUser` then serialised into localStorage and `initUser` parsed
  // back, round-tripping the stray key into every persisted session.
  on(authenticateUser, (state, { type: _type, ...tokenDto }) => tokenDto),
  on(unauthenticateUser, (state) => initialState)
);
